export enum IdleStorageKey {
    TimeoutModal = 'timeout_modal',
    TimeoutLogout = 'timeout_logout',
}
export enum IdleStorageValue {
    TimeoutModalClosed = 'timeout_modal_closed',
    TimeoutModalOpened = 'timeout_modal_opened',
    UserIsLogin = 'user_is_login',
    UserIsLogout = 'user_is_logout',
}
